import { forwardRef, Ref } from 'react';

import TagPrimitive, { TagProps as PrimitiveTagProps } from '../primitive';

import style from './TagInformation.module.scss';

type TagProps = Omit<PrimitiveTagProps, 'className'>;

const TagInformation = forwardRef((props: TagProps, ref: Ref<HTMLSpanElement>) => (
	<TagPrimitive {...props} ref={ref} className={style.tag} />
));
TagInformation.displayName = 'TagInformation';

export default TagInformation;
